import {Nullable} from "@data-force/app";
import {
    ClaimJobPhase,
    CompleteJobPhase,
    JobEntity,
    JobNotificationData,
    JobRequestParams,
    PhaseConfigNormalized,
} from "../../interfaces/store/actions/payload/job";
import {
    ClaimJobPhaseAction,
    ClearJobListDataAction,
    CompleteJobPhaseAction,
    DestroyConfirmClaimDialogAction,
    DestroyJobDrawerAction,
    GetJobListAction,
    GetJobPhaseWorkflowDefinitionsAction,
    GetPhaseConfigListAction,
    OpenJobEditorAction,
    ResetJobNotificationAction,
    SetActiveJobTypeAction,
    SetJobFilterTypeAction,
    SetJobListAction,
    SetJobListCursorAction,
    SetJobPhaseWorkflowDefinitionsAction,
    SetJobSearchAction,
    SetPhaseConfigListAction,
    SetSelectedJobAction,
    ShowConfirmClaimDialogAction,
    ShowJobDrawerAction,
    ShowJobNotificationAction,
    UpdateJobListAction,
} from "../../interfaces/store/actions/job";
import {
    CLAIM_JOB_PHASE,
    CLEAR_JOB_LIST_DATA,
    COMPLETE_JOB_PHASE,
    DESTROY_CONFIRM_CLAIM_DIALOG,
    DESTROY_JOB_DRAWER,
    GET_JOB_LIST,
    GET_JOB_PHASE_WORKFLOW_DEFINITIONS,
    GET_PHASE_CONFIG_LIST,
    OPEN_JOB_EDITOR,
    RESET_JOB_NOTIFICATION,
    SET_ACTIVE_JOB_TYPE,
    SET_JOB_FILTER_TYPE,
    SET_JOB_LIST,
    SET_JOB_LIST_CURSOR,
    SET_JOB_PHASE_WORKFLOW_DEFINITIONS,
    SET_JOB_SEARCH,
    SET_PHASE_CONFIG_LIST,
    SET_SELECTED_JOB,
    SHOW_CONFIRM_CLAIM_DIALOG,
    SHOW_JOB_DRAWER,
    SHOW_JOB_NOTIFICATION,
    UPDATE_JOB_LIST,
} from "./availableActions";
import {Cursor} from "../../interfaces/store/cursor";
import {WorkflowDefinition} from "../../interfaces/store/actions/payload/workflowDefinition";

export const getJobList = (payload?: JobRequestParams): GetJobListAction => ({
    type: GET_JOB_LIST,
    payload,
});

export const setJobList = (payload: JobEntity[]): SetJobListAction => ({
    type: SET_JOB_LIST,
    payload,
});

export const setSelectedJob = (payload: Nullable<JobEntity>): SetSelectedJobAction => ({
    type: SET_SELECTED_JOB,
    payload,
});

export const setJobListCursor = (payload: Nullable<Cursor>): SetJobListCursorAction => ({
    type: SET_JOB_LIST_CURSOR,
    payload,
});

export const setJobSearch = (payload: string): SetJobSearchAction => ({
    type: SET_JOB_SEARCH,
    payload,
});

export const claimJobPhase = (payload: ClaimJobPhase): ClaimJobPhaseAction => ({
    type: CLAIM_JOB_PHASE,
    payload,
});

export const completeJobPhase = (payload: CompleteJobPhase): CompleteJobPhaseAction => ({
    type: COMPLETE_JOB_PHASE,
    payload,
});

export const getJobPhaseWorkflowDefinitions = (): GetJobPhaseWorkflowDefinitionsAction => ({
    type: GET_JOB_PHASE_WORKFLOW_DEFINITIONS,
});

export const updateJobList = (payload: JobEntity[]): UpdateJobListAction => ({
    type: UPDATE_JOB_LIST,
    payload,
});

export const setJobPhaseWorkflowDefinitions = (payload: WorkflowDefinition[]): SetJobPhaseWorkflowDefinitionsAction => ({
    type: SET_JOB_PHASE_WORKFLOW_DEFINITIONS,
    payload,
});

export const setActiveJobType = (payload: string): SetActiveJobTypeAction => ({
    type: SET_ACTIVE_JOB_TYPE,
    payload,
});

export const setJobFilterType = (payload: string): SetJobFilterTypeAction => ({
    type: SET_JOB_FILTER_TYPE,
    payload,
});

export const clearJobListData = (): ClearJobListDataAction => ({
    type: CLEAR_JOB_LIST_DATA,
});

export const destroyJobDrawer = (): DestroyJobDrawerAction => ({
    type: DESTROY_JOB_DRAWER,
});

export const showJobDrawer = (payload: string): ShowJobDrawerAction => ({
    type: SHOW_JOB_DRAWER,
    payload,
});

export const getPhaseConfigList = (): GetPhaseConfigListAction => ({
    type: GET_PHASE_CONFIG_LIST,
});

export const setPhaseConfigList = (payload: PhaseConfigNormalized): SetPhaseConfigListAction => ({
    type: SET_PHASE_CONFIG_LIST,
    payload,
});

export const showConfirmClaimDialog = (payload: JobEntity): ShowConfirmClaimDialogAction => ({
    type: SHOW_CONFIRM_CLAIM_DIALOG,
    payload,
});

export const destroyConfirmClaimDialog = (): DestroyConfirmClaimDialogAction => ({
    type: DESTROY_CONFIRM_CLAIM_DIALOG,
});

export const showJobNotification = (payload: JobNotificationData): ShowJobNotificationAction => ({
    type: SHOW_JOB_NOTIFICATION,
    payload,
});

export const resetJobNotification = (): ResetJobNotificationAction => ({
    type: RESET_JOB_NOTIFICATION,
});

export const openJobEditor = (payload: boolean): OpenJobEditorAction => ({
    type: OPEN_JOB_EDITOR,
    payload,
});
